
import { AD_LAYOUT_STUBS } from "@consts";
import { getCrosswordAnswers } from "@/common/services/crosswordSolverService";

// in case we need this somewhere else, we can extract this into a separate file
const setHtmlSmoothScroll = (value) => {
	const classList = document?.documentElement?.classList;
	const className = "smooth-scroll";

	if (!classList) {
		return;
	}

	if (value === true) {
		classList.add(className);
	} else {
		classList.remove(className);
	}
};

export default {
	name: "CrosswordSolver",
	data() {
		return {
			results: null,
			AD_LAYOUT_STUBS,
			isLoading: false,
		};
	},
	computed: {
		resultCountText() {
			return `${this.results.length} word${
				this.results.length > 1 ? "s" : ""
			}`;
		},
		searchIsDirty() {
			return this.results !== null;
		},
	},
	destroyed() {
		setHtmlSmoothScroll(false);
	},
	methods: {
		async onFormSubmit(params) {
			this.isLoading = true;
			const items = await getCrosswordAnswers(
				this.$axios,
				this.$config,
				params
			);

			this.results = items.map((w) => w.toUpperCase());
			this.isLoading = false;

			if (!this.isExtraLargeDevice) {
				setHtmlSmoothScroll(true);
				document
					.querySelector("label[for='known_letters']")
					.scrollIntoView();
			}
		},
	},
};
